import {
  Button,
  createStyles,
  Theme,
  Typography,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import { useTranslations } from "adapters/i18n";
import clsx from "clsx";
import React, { type ComponentProps } from "react";

export type BenchmarkButtonProps = Omit<
  ComponentProps<typeof Button>,
  "variant"
> &
  WithStyles<typeof styles>;

const BenchmarkButton = ({
  classes,
  className,
  ...rest
}: BenchmarkButtonProps) => {
  const { t } = useTranslations();

  const buttonClass = clsx(classes.button, className);

  return (
    <Button className={buttonClass} variant="contained" {...rest}>
      <div className={classes.contentWrapper}>
        <QueryStatsIcon
          aria-hidden="true"
          aria-label="Benchmark Icon"
          className={classes.icon}
        />
        <Typography className={classes.text} data-testid="benchmark-text">
          {t("common:go-benchmark")}
        </Typography>
      </div>
    </Button>
  );
};

const styles = (theme: Theme) =>
  createStyles({
    button: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "8px",
      color: theme.palette.common.white,
      height: "40px",
      minWidth: 0,
      padding: "12px 16px",
      transition: "filter 0.3s",
      width: "fit-content",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        filter: "brightness(0.8)",
      },
      "&:active": {
        backgroundColor: theme.palette.primary.main,
        filter: "brightness(0.8)",
      },
    },
    contentWrapper: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      justifyContent: "center",
    },
    icon: {
      color: "inherit",
      fontSize: "16px !important",
    },
    text: {
      color: "inherit",
      fontSize: "12px",
      fontWeight: 500,
      textTransform: "none",
      whiteSpace: "nowrap",
      "@media (max-width: 1280px)": {
        display: "none",
      },
    },
  });

export default withStyles(styles)(BenchmarkButton);
